export const textTransformation = (text: string | undefined) => {
  if (text) {
    // URL을 인식할 정규 표현식
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // 각 줄을 분할하여 처리
    return text.split("\\n").map((line, key) => {
      // URL을 <a> 태그로 변환하는 함수
      const transformedLine = line.split(urlRegex).map((part, index) => {
        if (urlRegex.test(part)) {
          // URL인 부분은 <a> 태그로 변환
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              {part}
            </a>
          );
        }
        return part; // URL이 아닌 텍스트 부분은 그대로 반환
      });

      return (
        <div key={key}>
          {transformedLine}
          <br />
        </div>
      );
    });
  }
};
